import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { Api } from 'api';
import { root } from 'root/sagas';
import { isProductionEnvironment } from 'myParkdUtils/utils';
import localForage from 'localforage';
import rootReducer from 'root/rootReducer';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from "@sentry/react";


const persistConfig = {
    key: 'myparkd',
    storage: localForage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
});

export const store = configureStore({
    reducer: persistedReducer,

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: true,
            serializableCheck: false, // Disable serializable checks for persist
        }).concat(sagaMiddleware), // Add saga middleware
    enhancers: (getDefaultEnhancers) => {
        return getDefaultEnhancers().concat(sentryReduxEnhancer);
    },
    devTools: !isProductionEnvironment(), // Enables Redux DevTools in development mode
});

Api.init({
    name: 'be.app.parkd (WEB)',
    version: '0.0.1',
    env: 'dev', // only applies when env.VITE_ENVIRONMENT is undefined! (see Api.init() -> setEndpoint())
});

sagaMiddleware.run(root);

export let persistor = persistStore(store);
